export default class BannerNotificationType {
    static NOTICE = 'notice'
    static CONFIRMATION = 'confirmation'
}
